module.exports = __webpack_public_path__ + "img/case9.9e9634f1.png";